import Vue from 'vue'
import App from './App.vue'
// ./router/index.js   index.js 可以省略
import router from './router' 
import store from './store'

// 阻止启动生产消息
Vue.config.productionTip = false

new Vue({
	router, // 路由
	store, // 跟实例状态存储，子组件通过 this.$store 访问
	render: h => h(App) // APP 组件渲染 h 即 vm.$createElement
}).$mount('#app')